<template>
	<div class="ng-scope show-sticky-calc blog-wraaper" :class="openModal ? 'modal-open' : ''">
		<headerNavigation :isHome="true" @openLoginMadal="openLoginMadal" @changeRegister="changeRegister">
		</headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;"></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="bg-white">
			<div class="breadcrumb-container container ">
				<div class="row">
					<div class="col-xs-24">
						<div class="comp-breadcrumbs-container">
							<ul class="breadcrumbs-list clearfix breadcrumbs-not-empty">
								<li class="breadcrumb-list-item active">
									<a href="javascript:void()" @click="openPage('/')" class="site-secondary-link breadcrumb-link breadcrumb1">{{$t('common.home')}}</a>
								</li>
								<li class="breadcrumb-list-item ">
									<span class="breadcrumb-active-label breadcrumb2">{{$t('common.printingknowledge')}}</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="article-info">
				<div class="content-area-infos">
					<h1 class="heading ">{{infos.title}}</h1>
					<!-- <p class="text">
						Written by <span class="author">{{infos.title}}</span> - Updated on <span>October 3, 2025</span>
					</p> -->
					<p class="text">
						<!-- {{$t('product.category')}} -->{{infos.subheading}}
					</p>
					<img :src="infos.img" class="banner" v-if="infos.img"/>
				</div>
			</div>
			<div class="article-contents-wrapper">
				<div class="article-contents">
					<div class="pb-12 article-content__wrapper">
						<div v-html="infos.content"></div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<loginModal ref="loginRef" :isShow="showLoginModal" @closeLoinMadal="closeLoinMadal"></loginModal>
		<div v-if="openModal" class="modal-backdrop fade ng-scope in" style="z-index: 1040;"></div>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import loginModal from '../../components/loginModal.vue'
	import {queryPrintingKnowledgeInfos} from '../../api/api.js'
	export default {
		components: {
			headerNavigation,
			footers,
			loginModal
		},
		data() {
			return {
				isMobile: false,
				showLoginModal: false,
				openModal: false,
				blogNo:'',
				infos:{}
			};
		},
		created() {
			this.isMobile = this.webIsMobile()
			if(this.$route.query.no){
				this.blogNo = this.$route.query.no;
				this.init()
			}
		},
		methods: {
			init(){
				var that = this;
				let params = {
					id:this.blogNo
				}
				queryPrintingKnowledgeInfos(params).then(res => {
					if (res.code == 200) {
						that.infos = res.data
					}
				})
			},
			openLoginMadal() {
				this.showLoginModal = true
				this.changeRegister(false)
			},
			closeLoinMadal() {
				this.showLoginModal = false
			},
			changeRegister(e) {
				this.$refs.loginRef.changeRegisterType(e)
				this.showLoginModal = true
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/blog.css");
	.global-header-spacer {
		height: 60px !important;
		display: block !important;
	}
</style>